import React from 'react';
import { Button,  notification, Form, type FormProps, Input, Card } from 'antd';
import { CouponService } from "./../../services/CouponService";
// import 'ckeditor5/ckeditor5.css';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, List } from 'ckeditor5';


interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();

    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
        })

    }, [props?.record])


    const onFinish: FormProps["onFinish"] = async (values) => {


        const data = {
            coupon_id: props?.record.coupon?.id,
            code: values.code
        }


        // if (props?.record?.id) {
        //     var res = await CouponService.updateCouponCode(data, props.record.id)
        // } else {
        var res = await CouponService.saveCouponCode(data)
        form.resetFields();
        // }

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card
            title={'Create Coupon Code'}
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    code: '',
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >



                <Form.Item
                    label="Code"
                    name="code"
                    rules={[{ required: true, message: 'Please fill coupon code' }]}
                >
                    <Input />
                </Form.Item>




                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
